import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useMutation } from '@tanstack/react-query';

import { backofficeService } from '../../../../application/BackofficeService';
import useErrorMiddleware from '../../../../hooks/errorMiddleware/useErrorMiddleware';
import { useShowSnackbarMessage } from '../../../../hooks/snackbarMessage/useShowSnackbarMessage';

interface UseUpdateProjectTrafficProps {
  projectId: string;
  traffic: boolean;
}

type UseUpdateProjectTrafficResponse = ServiceResponse<
  ({ projectId, traffic }: UseUpdateProjectTrafficProps) => void,
  void
>;

// Hooks act as 'Adapter' layer.
export const useUpdateProjectTraffic = (): UseUpdateProjectTrafficResponse => {
  const { sessionExpiredLogout } = useErrorMiddleware();
  const { showSnackbarMessage } = useShowSnackbarMessage();

  const { isLoading, isSuccess, isError, mutate } = useMutation(
    ({ projectId, traffic }: UseUpdateProjectTrafficProps): Promise<void> => {
      return backofficeService.updateProjectTraffic({
        projectId,
        traffic,
      });
    },
    {
      onError: (err: any) => {
        console.info(`Planner Backoffice Update Project Traffic Error:`, err);
        if (err?.response?.status === 401) {
          sessionExpiredLogout();
          return;
        }
        showSnackbarMessage({
          messageIntlId: `infoerror.${err?.response?.data?.messageId ?? `network_error`}`,
        });
      },
      onSuccess: () => {
        showSnackbarMessage({
          type: `success`,
          messageIntlId: `backoffice.clients.projects.updated_successfully`,
        });
      },
    }
  );

  return {
    run: ({ projectId, traffic }: UseUpdateProjectTrafficProps) => mutate({ projectId, traffic }),
    error: isError,
    success: isSuccess,
    isLoading: isLoading,
  };
};
